import { Avatar } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import EditIcon from 'assets/icons/svg/Edit/index';
import { ReactComponent as DeleteIcon } from "assets/icons/Trush.svg";
import { HintField, Text } from "components";
import Button from "components/button/Button";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

const MournersList = ({
  drawerDisplay,
  handleClick,
  mourners,
  handleDelete,
  setDisable,
  isEdit,
  mourner,
  onEditClick,
  ...props
}) => {
  const history = useHistory();
  const [error, setError] = useState("");
  const formik = { ...props };
  return (
    <div
      className={!drawerDisplay ? "mourners-list" : "drawer-mourner-list px-8"}
    >
      {!drawerDisplay && <Text className="sub-title">Mourners list</Text>}
      <div className="list-contant">
        {mourners?.length > 0 &&
          mourners?.map((mourner, index) => {
            return (
              <div className="member-card" key={index}>
                <div className="card-content">
                  <div className="member-container"
                    onClick={mourner?.first_name ? (e) => {
                      e.stopPropagation();
                      history. push(`/member-details/${mourner?.account_id}?q=${mourner?._id}&tab=Family`);
                    } : null}
                    style={mourner?.first_name ?{
                      cursor: "pointer",
                    } : {}}
                  >
                    <div className="member-img">
                      <Avatar
                        className="avatar"
                        style={{
                          background:
                            mourner?.member_id || mourner?._id
                              ? "#4CAF50"
                              : "#8E8E8E",
                          height: "40px",
                          borderRadius: "6px",
                          width: "40px",
                        }}
                        alt={`${mourner.first_name}`}
                        src={
                          mourner?.profile_img && mourner?.profile_img !== ""
                            ? mourner?.profile_img
                            : "/example.jpg"
                        }
                      ></Avatar>
                    </div>
                    <div className="member-name">
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <span>
                          {mourner?.member_id || mourner?._id
                            ? `${mourner?.first_name} ${mourner?.last_name}`
                            : mourner?.email}
                        </span>
                        {mourner?.account_id && (
                          <a
                            href={`/member-details/${mourner?.account_id}`}
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                          >
                            <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                          </a>
                        )}
                      </div>
                      <div className="member-t">{`${
                        mourner?.relation?.name ?? mourner?.relation
                      }`}</div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    {drawerDisplay && (
                      <div
                        className={`cursor-pointer mr-2`}
                        onClick={() => {
                          onEditClick(mourner);
                        }}
                      >
                        <EditIcon
                          fontSize="large"
                        />
                      </div>
                    )}
                    <div
                      className={`cursor-pointer`}
                    >
                      <DeleteIcon
                        onClick={() => {
                          setDisable(false);
                          handleDelete(index);
                        }}
                        width={24}
                        height={24}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {!drawerDisplay && (
        <div className="py-10" style={{ marginLeft: 20 }}>
          {!mourners?.length > 0 ? <HintField error={error} /> : null}
          <Button
            variant="primary"
            size="md"
            style={{ minWidth: "320px" }}
            onClick={() => {
              if (mourners?.length > 0 || formik?.values?.doesnt_have_mourner)
                handleClick();
              else setError("Add 1 mourner at least to continue");
            }}
          >
            Continue
          </Button>
        </div>
      )}
    </div>
  );
};

export default MournersList;
